import request from '@/utils/request'

// 获取用户信息
export function getProfile() {
  return request({
    url: '/profile',
    method: 'get'
  })
}

// 获取通知 - 后端路径是 /admin/profile/nnotice
export function getNotice() {
  return request({
    url: '/profile/nnotice',
    method: 'get'
  })
}

// 获取通知列表
export function getNoticeList() {
  return request({
    url: '/profile/lsnotice',
    method: 'get'
  })
}

// 更新用户信息
export function updateProfile(data) {
  return request({
    url: '/profile/update',
    method: 'post',
    data
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/profile/password',
    method: 'post',
    data
  })
}

// 标记通知已读
export function catNotice(data) {
  return request({
    url: '/profile/catnotice',
    method: 'post',
    data
  })
}

// 通知（兼容旧版）
